import { startAutoSaveTimer, stopAutoSaveTimer } from '~core';
import { editorConfig } from '~config';

export const updateAutoSaveInterval = async (newInterval) => {
  stopAutoSaveTimer();
  editorConfig.autoSaveInterval = newInterval;
  await startAutoSaveTimer();
};
